module.exports = __webpack_public_path__ + "img/w10-b1.c46a2c3d.jpg";